import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useBingBusinessManagerStore = defineStore({
  id: 'bingBusinessManagerStore',
  state: () => ({
    bingBusinessManagers: [],
    bingBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getBingBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.bingBusinessManagersLoading = true

      try {
        const {data} = await axios.get('bing/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.bingBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.bingBusinessManagersLoading = false
      }
    },
  },
})
